import { Group, Text } from '@mantine/core'

import styles from './TimingBreakdown.module.css'

export const TimingBreakdown = (props: {
  dialogue: string
  bracket: string
}) => (
  <>
    <Group justify="space-between">
      <Text className={styles.text}>Dialogue</Text>
      <Text className={styles.text}>{props.dialogue}</Text>
    </Group>
    <Group justify="space-between">
      <Text className={styles.text}>Brackets</Text>
      <Text className={styles.text}>{props.bracket}</Text>
    </Group>
  </>
)
